import { canv } from "@/canv/global";
import { getNewStartY } from "@/shapeStorage/utils";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeArrowLeftRight extends Shape {
    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 2) / 3 - 2 * horizontalPadding;
        const allowedHeight = (height * 3) / 5 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        this.updateTextDims(textPart);

        textPart.startX = x + width / 2 - textPart.width / 2;

        textPart.startY = getNewStartY(textPart, y, height, height / 4, null);

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y + height / 2);
        canv.ctx.lineTo(x + width / 3, y);
        canv.ctx.lineTo(x + width / 3, y + height / 5);
        canv.ctx.lineTo(x + (width * 2) / 3, y + height / 5);
        canv.ctx.lineTo(x + (width * 2) / 3, y);
        canv.ctx.lineTo(x + width, y + height / 2);
        canv.ctx.lineTo(x + (width * 2) / 3, y + height);
        canv.ctx.lineTo(x + (width * 2) / 3, y + (height * 4) / 5);
        canv.ctx.lineTo(x + width / 3, y + (height * 4) / 5);
        canv.ctx.lineTo(x + width / 3, y + height);
        canv.ctx.lineTo(x, y + height / 2);
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" viewBox="0 0 27 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="${fill}" stroke="${stroke}" d="M26 14.5L17.0424 2V9.55666H9.95757V2L1 14.5L9.95757 27V19.4433H17.0424V27L26 14.5Z"/>
            </svg>
        `;
    }
}
